import { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Tabs from '../../tabs/tabs';
import formatDate from '../../../helpers/format-date';
import { SidepanelReadTypes } from './types';

import styles from '../transaction.module.css';

export default function NostroTransactionSidepanelRead({
  tabs,
  parentRef,
  parentScroll = 0,
  deletedAt,
}: SidepanelReadTypes): React.JSX.Element {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      {deletedAt && (
        <div className={styles.deleted}>{`Transaction deleted ${formatDate(
          deletedAt,
          true,
        )}`}</div>
      )}
      <Tabs
        enableRouting
        isTransactionsTabs
        withSticky
        // eslint-disable-next-line react-hooks/refs
        withShadow={parentScroll > Number(scrollRef.current?.offsetTop) - 130}
        onRouterClick={() => {
          if (parentScroll >= Number(scrollRef.current?.offsetTop) - 130) {
            parentRef?.current?.scrollTo({
              top: Number(scrollRef.current?.offsetTop) - 130,
            });
          }
        }}
        moreButtonClassName={styles.transactionMoreButton}
        tabs={[
          {
            name: 'General Info',
            path: tabs?.generalPath || '',
          },
          {
            name: 'Status log',
            path: tabs?.logPath || '',
          },
          {
            name: 'Change log',
            path: tabs?.changeLogPath || '',
          },
          {
            name: 'Comments',
            path: tabs?.commentsPath || '',
          },
        ]}
      />
      <div ref={scrollRef}>
        <Outlet />
      </div>
    </>
  );
}
